module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portal_program_content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-lg-between"
  }, [_c('div', {
    staticClass: "col-md-12 g-pt-50 g-pt-100--md g-pb-70"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12 pp_image g-px-0"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "0",
      "padding-bottom": "56.25%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "loading": "lazy",
      "src": "https://www.youtube-nocookie.com/embed/j03iJHt8q2A?si=RLQgQUuQpspJ0B-n&showinfo=0&rel=0&modestbranding=1&autoplay=1&mute=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12 second"
  }, [_c('div', {
    staticClass: "portal_info ml-md-4"
  }, [_c('div', {
    staticClass: "pp_benefit_content"
  }, [_c('p', {
    staticClass: "pp_title"
  }, [_vm._v("User Testimonial")]), _vm._v(" "), _c('div', {
    staticClass: "program_desc_container"
  }, [_c('p', {
    staticClass: "pp_description"
  }, [_vm._v("Hear from Dr. Kristin Reed about how the Champions for Sight® program has helped her make an impact in her community and her practice. ")]), _vm._v(" "), _c('p', {
    staticClass: "pp_description"
  }, [_vm._v("By participating in the program, you and your team can make a tangible difference in the lives of others!")])])])])])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e42e8ece", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e42e8ece"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/homeData/HomePromo.vue
// module id = 578
// module chunks = 4